module.exports = __webpack_public_path__ + "static/media/news_02.90c806a9.jpg";